// Object Config for Toast Message
export const TOAST_CONFIG = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  theme: "colored",
};

// Snackbar Variant
export const SNACKBAR_VARIANT = {
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
}

// Common error message config
export const ERROR_MESSAGE = {
  INTERNET_ERROR: "No internet connection, Please check your connection and try again.",
  SOMETHING_WENT_WRONG: "Something went wrong, please try again.",
  FAILED_TO_FETCH_DATA: "Failed to fetch data."
}

export const LOGIN_AND_FORGOT_PASSWORD = {
  LOGIN: "",
  FORGOT_PASSWORD: {
    LINK_SEND: {
      SUCCESS: "Forgot password link has been sent to your email.",
      INVALID_MAIL: "The email address is not registered with the system",
      FAILED: "Something went wrong, please try again."
    }
  },
  CHANGE_PASSWORD: "Password changed successfully, login with new credential",
  CHANGE_PASSWORD_FAILED: "Failed to change password, please try again later"
}

export const FORM_VALIDATIONS = {
  TEXT_INPUT: {
    REGEX: {
      // eslint-disable-next-line no-useless-escape
      INITIAL: /^(?![0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?`~]).*$/,
      // eslint-disable-next-line no-useless-escape
      SECONDARY: /^(?!^\d+$)[A-Za-z0-9,\/()\-_.&]*$/,
    },
    MESAAGE: {
      INITIAL: "Invalid input",
      SECONDARY: "Invalid input",
    },
  },

  WC_ESIC_INPUT: {
    // eslint-disable-next-line no-useless-escape
    REGEX: /^(?![!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?~]).*$/,
    MESSAGE: "Invalid input",
  },

  NUMBER_INPUT: {
    // eslint-disable-next-line no-useless-escape
    REGEX: /^\d{10,}$/, //  /^\d{10}$/ - Previous,
    MESAAGE: "Only Digits are allowed (At least 10)", //"Only 10-digit numbers are allowed",
  },

  MIN_NO_OF_LABOUR: {
    REGEX: /^\d{1,2}$/,
    MESSAGE: "Maximum 2 digits are allowed",
    NON_ZERO_REGEX: /^[1-9]\d*$/,
    NON_ZERO_REGEX_MESSAGE: "Labours must be more than 0",
  },

  PASSWORD: {
    // REGEX: /^[^\s]*$/,
    VALIDATION: [
      {
        regex: /^.{6,}$/,
        message: "Password length at least be 6 characters.",
      },
      {
        regex: /(?=.*[A-Z])/,
        message: "Include an uppercase letter.",
      },
      {
        regex: /(?=.*[a-z])/,
        message: "Include a lowercase letter.",
      },
      {
        regex: /(?=.*\d)/,
        message: "Include a number.",
      },
      {
        regex: /(?=.*[@$!%*?&])/,
        message: "Include a special character.",
      },
      {
        regex: /^\S*$/,
        message: "Password should not contain any spaces.",
      },
    ],

    //Old regex to check any spaces
    // REGEX: /^[^\s]*$/,
    // MESSAGE: "Password should not contain only spaces",

    // New regex to check for only spaces
    REGEX: /^(?=.*\S).{1,}$/,
    MESSAGE: "Password should not consist of only spaces",
  },

  EMAIL: {
    // REGEX: /^[^\s]*$/ //Old regex,
    // MESSAGE: "Email id should not contain any spaces", // Old messess
    REQUIRED: "Email is required",
    VALIDATIONS: [
      {
        regex: /.+@.+\..+/,
        message: "Email must contain '@' and a valid domain.",
      },
      {
        regex: /^[^@]+@[^@]+\.[^@]+$/,
        message: "Email can't start or end with '@' or a dot.",
      },
      {
        regex: /^(?!.*\.\.)/,
        message: "Email can't have two dots in a row.",
      },
      {
        regex: /@[a-zA-Z0-9-]+\./,
        message: "Email must have a valid domain name (example.com).",
      },
      {
        regex: /\.[a-zA-Z]{2,}$/,
        message: "Email should ends with at least 2 letters (.uk .com, .org).",
      },
      {
        regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid email format.",
      },
    ],
  },

  UNIQUE_PREFIX: {
    REGEX: /^[A-Z]{3}$/,
    MESSAGE: "Only 3 alphabetic characters are allowed",
  },

  LOCATION_NAME_PERFIX: {
    REGEX: /^(?=.*[A-Z])[A-Z0-9]{3}$/,
    MESSAGE: "Only 3 alphabets or alphanumeric characters are allowed",
  },
};

export const USE_FORMIK_SCHEMA = {
  ROLE_MASTER: {
    ROLE_NAME: "Enter role name",
    RESPONSIBILITY:
      "Responsibility cannot be empty, select at least one from above",
  },

  PLANT_MASTER: {
    PLANT_NAME: "Enter branch name",
    ABBRIVATIONS: "Enter unique prefix",
    EMERGENCY_CONTACT: "Enter emergency contact number",
    WEEKENDS_MIN_ONE: "Select at least 1 day",
    WEEKENDS_MAX_TWO: "You can select maximum 2 days",
    WEEKENDS_REQUIRED: "Week offs cannot be empty",
    ADDRESS: "Enter branch address",
    COUNTRY_CODE: "Select country code",
    EMERGENCY_CONTACT_NAME: "Enter contact name",
    EMERGENCY_CONTACT_NUMBER: "Enter contact number",
  },

  USER_MASTER: {
    USER_NAME: "Enter user name",
    PHONE_NUMBER: "Enter phone number",
    EMAIL: "Enter a valid email address",
    ROLE: "Select role",
    COUNTRY_CODE: "Select country code",
    PLANT: "Select branch",
    DEPT: "Department cannot be empty, select at least one department",
  },

  DEPARTMENT_MASTER: {
    DEPT_NAME: "Enter department name",
    ABBRIVATIONS: "Enter unique prefix",
    BRANCH: "Select branch",
    INCHARGE: "Select incharge",
  },

  ACTIVITY_MASTER: {
    ACTIVITY_NAME: "Enter activity name",
  },

  PPE_MASTER: {
    PPE_NAME: "Enter PPE name",
    DOCUMENT: "Please upload documents",
  },

  HOLIDAY_MASTER: {
    HOLIDAY_NAME: "Enter holiday name",
    DATE: "Select date",
    PLANT: "Select plant or project",
  },

  AREA_MASTER: {
    AREA_NAME: "Enter area name",
    BRANCH: "Select branch",
    DEPT: "Select department",
  },

  CONTRACTOR_MASTER: {
    CONTRACTOR_NAME: "Enter contractor name",
    PHONE_NUMBER: "Enter phone number",
    CONTACT_PERSON_NAME: "Enter contact person name",
    CONTACT_PERSON_PHONE_NUMBER: "Enter contact person number",
    EMAIL: "Enter a valid email address",
    LICENCE_EXPIRY: "Select date",
    OFFICE_LOCATION: "Enter office address",
    COUNTRY_CODE: "Select country code",
    ESIC_NUMBER: "Enter ESIC Number",
  },

  LABOUR_MASTER: {
    LABOUR_NAME: "Enter labour name",
    PHONE_NUMBER: "Enter phone number",
    COUNTRY_CODE: "Select country code",
    SELECT_LABOUR_TYPE: "Select labour category",
    SELECT_CONTRACTOR: "Select contractor",
  },

  AUDIT_MASTER: {
    NESTED: {
      ID: "ID is required",
      NAME: "Name is required"
    },
    SELECT_AUDIT_TYPE_CATEGORY: "Select audit type category",
    SELECT_AUDIT_TYPE: "Select audit type",
    SELECT_BRANCH: "Select branch",
    SELECT_DEPARTMENT: "Select department",
    SELECT_AREA: "Select area",
    SELECT_START_DATE: "Select start date",
    SELECT_END_DATE: "Select end date",
    SELECT_AUDITOR: "Select auditor",
    SELECT_AUDITEE: "Select auditee",
  },

  THIRD_PARTY_AUDIT_MASTER: {
    NESTED: {
      ID: "ID is required",
      NAME: "Name is required"
    },
    SELECT_AUDIT_TYPE_CATEGORY: "Select audit type category",
    SELECT_AUDIT_TYPE: "Select audit type",
    SELECT_BRANCH: "Select branch",
    SELECT_DEPARTMENT: "Select department",
    SELECT_AREA: "Select area",
    SELECT_START_DATE: "Select start date",
    SELECT_END_DATE: "Select end date",
    ENTER_ACTIVITIES_COUNT: "Enter count of total activities",
    ENTER_NC_ACTIVITIES_COUNT: "Enter count of NC activities",
    ENTER_CLOSED_ACTIVITIES_COUNT: "Enter count of closed activities",
  },

  THIRD_PARTY_ACTIVITY_MODAL: {
    ACTIVITY_NAME: "Enter activity name",
    AUDITOR_OBSERVATION: "Enter auditor observation",
    CAPA: "Enter CAPA",
    ATTACHMENTS: "Add at least one file or document for the given NC point",
  },

  AUDIT_TYPE_MASTER: {
    AUDIT_NAME: "Enter audit type",
    ABBRIVATIONS: "Enter unique prefix",
    AUDIT_TYPE_CATEGORY: "Select audit type category",
  },

  AUDIT_TYPE_CATEGORY_MASTER: {
    CATEGORY_NAME: "Enter audit type category",
  },

  COMPANY_DETAILS: {
    NAME: "Enter company name",
    ABBRIVATIONS: "Enter unique prefix",
    ADDRESS: "Enter company address",
    EMAIL: "Enter email",
    PHONE_NUMBER: "Enter phone number",
    COUNTRY_CODE: "Select country code",
    DATE_FORMAT: "Select date format",
    TIME_ZONE: "Select time zone",
  },

  REPORT_MASTER: {
    AUDIT_TYPE: "Select audit type",
    BRANCH: "Select branch",
    DEPARTMENT: "Select department",
    AREA: "Select area",
    SELECT_AUDITOR: "Select auditor",
    SELECT_AUDITEE: "Select auditee",
    FROM_DATE: "Select from date",
    TO_DATE: "Select to date",
  },

  // ---------------------- Zingworks Validation Schema --------------------
  ACCOUNT_MASTER: {
    NAME: "Enter company name",
    EMAIL: "Enter company email",
    ABBRIVATIONS: "Enter unique prefix",
    COORDINATOR_NAME: "Enter coordinator name",
    COUNTRY_CODE: "Select country code",
    COORDINATOR_NUMBER: "Enter coordinator number",
    ADDRESS: "Enter office address",
    ACCOUNT_TYPE: "Select account type",
    DATE_FORMAT: "Select date format",
    TIME_ZONE: "Select time zone",
    SUPERADMIN_NAME: "Enter super admin name",
    SUPERADMIN_EMAIL: "Enter super admin email",
    SUPERADMIN_NUMBER: "Enter super admin number",
  },
};


// Toast Message for different component or pages
export const APP_MESSAGE = {
  // ----------- App Dashboard ----------
  APP_DASHBOARD: {
    FAILED: "Failed to fetch dashboard data.",
  },
  // ----------- Role Master ------------
  ROLE_MASTER: {
    CREATE: {
      SUCCESS: "Role is created successfully.",
      FAILED: "Failed to create role."
    },
    UPDATE: {
      SUCCESS: "Role has been updated successfully.",
      FAILED: "Failed to update role."
    },
    DELETE: {
      SUCCESS: "Role has been removed successfully.",
      FAILED: "Failed to remove role."
    },
    GET: {
      FAILED: "Failed to fetch responsibility."
    },
    DUPLICATE_ROLE: "Role name already exists."
  },

  PLANT_MASTER: {
    CREATE: {
      SUCCESS: "Branch is created successfully.",
      FAILED: "Failed to create branch."
    },
    UPDATE: {
      SUCCESS: "Branch has been updated successfully.",
      FAILED: "Failed to update branch."
    },
    DELETE: {
      SUCCESS: "Branch has been removed successfully.",
      FAILED: "Failed to remove branch."
    },
    DUPLICATE_PLANT_NAME: "Branch name already exists."
  },

  USER_MASTER: {
    CREATE: {
      SUCCESS: "User is created successfully.",
      FAILED: "Failed to create user."
    },
    UPDATE: {
      SUCCESS: "User has been updated successfully.",
      FAILED: "Failed to update user."
    },
    DELETE: {
      SUCCESS: "User has been removed successfully.",
      FAILED: "Failed to remove user."
    },
    DUPLICATE_USER_NAME: "User name already exists."
  },

  ACTIVITY_MASTER: {
    CREATE: {
      SUCCESS: "Activity is created successfully.",
      FAILED: "Failed to create activity."
    },
    UPDATE: {
      SUCCESS: "Activity has been updated successfully.",
      FAILED: "Failed to update activity."
    },
    DELETE: {
      SUCCESS: "Activity has been removed successfully.",
      FAILED: "Failed to remove activity."
    },
    DUPLICATE_ACTIVITY: "Activity already exists.",
    // BULK_CHECKLIST_UPLOAD: {
    //   REQUIRED_FILE: "Please select an excel file to upload bulk check list points.",
    //   INVALID_FILE_FORMAT: "Invalid file format.",
    //   FAILED: "Failed to upload check list points.",
    //   SUCCESS: "Check list points are uploaded successfully."
    // }
  },

  PPE_MASTER: {
    CREATE: {
      SUCCESS: "PPE is created successfully.",
      FAILED: "Failed to create PPE."
    },
    UPDATE: {
      SUCCESS: "PPE has been updated successfully.",
      FAILED: "Failed to update PPE."
    },
    DELETE: {
      SUCCESS: "PPE has been removed successfully.",
      FAILED: "Failed to remove PPE."
    },
    IMAGE_UPLOAD: {
      SUCCESS: "Image is uploaded successfully.",
      FAILED: "Failed to upload image."
    },
    DUPLICATE_PPE_NAME: "PPE name already exists."
  },

  HOLIDAY_MASTER: {
    CREATE: {
      SUCCESS: "Holiday is created successfully.",
      FAILED: "Failed to create holiday."
    },
    UPDATE: {
      SUCCESS: "Holiday has been updated successfully.",
      FAILED: "Failed to update holiday."
    },
    DELETE: {
      SUCCESS: "Holiday has been removed successfully.",
      FAILED: "Failed to remove holiday."
    },
    DUPLICATE_HOLIDAY_NAME: "Holiday name already exists.",
    BULK_HOLIDAY_UPLOAD: {
      REQUIRED_FILE: "Please select an excel file to upload bulk holidays.",
      INVALID_FILE_FORMAT: "Invalid file format.",
      PLANT_ID: "Please select plant.",
      FAILED: "Failed to upload holidays.",
      SUCCESS: "Holidays are uploaded successfully."
    }
  },

  LOCATION_MASTER: {
    CREATE: {
      SUCCESS: "Department is created successfully.",
      FAILED: "Failed to create department."
    },
    UPDATE: {
      SUCCESS: "Department has been updated successfully.",
      FAILED: "Failed to update department."
    },
    DELETE: {
      SUCCESS: "Department has been removed successfully.",
      FAILED: "Failed to remove department."
    },
    FETCHED: {
      SUCCESS: "Users fetched successfully.",
      FAILED: "Failed to fetch users."
    },
    DUPLICATE_LOCATION_NAME: "Department name already exists."
  },

  AREA_MASTER: {
    CREATE: {
      SUCCESS: "Area is created successfully.",
      FAILED: "Failed to create area."
    },
    UPDATE: {
      SUCCESS: "Area has been updated successfully.",
      FAILED: "Failed to update area."
    },
    DELETE: {
      SUCCESS: "Area has been removed successfully.",
      FAILED: "Failed to remove area."
    },
    DUPLICATE_LOCATION_NAME: "Area name already exists."
  },

  CONTRACTOR_MASTER: {
    FETCHED: {
      FAILED: "Failed to fetch contractor."
    },
    CREATE: {
      SUCCESS: "Contractor is created successfully.",
      FAILED: "Failed to create contractor."
    },
    UPDATE: {
      SUCCESS: "Contractor has been updated successfully.",
      FAILED: "Failed to update contractor."
    },
    DELETE: {
      SUCCESS: "Contractor has been removed successfully.",
      FAILED: "Failed to remove contractor."
    },
    DUPLICATE_CONTRACTOR_NAME: "Contractor name already exists."
  },

  LABOUR_MASTER: {
    FETCHED: {
      CONTRACTOR_FAILED: "Failed to fetch contractor.",
      LABOUR_FAILED: "Failed to fetch labour."
    },
    CREATE: {
      SUCCESS: "Labour is created successfully.",
      FAILED: "Failed to create labour."
    },
    UPDATE: {
      SUCCESS: "Labour has been updated successfully.",
      FAILED: "Failed to update labour."
    },
    DELETE: {
      SUCCESS: "Labour has been removed successfully.",
      FAILED: "Failed to remove labour."
    },
    DUPLICATE_LABOUR_NAME: "Labour name already exists.",
    BULK_CERTIFICATE_UPLOAD: {
      SAME_FILE_UPLOAD: "You cannot select same file again.",
      REQUIRED_FILE: "Please select file of type .pdf .doc .docx .png .jpeg .jpg",
      INVALID_FILE_FORMAT: "Invalid file format.",
      FAILED: "Failed to upload files.",
      SUCCESS: "Files are uploaded successfully."
    }
  },

  AUDIT_MASTER: {
    CREATE: {
      SUCCESS: "Audit is created successfully.",
      FAILED: "Failed to create audit."
    },
    UPDATE: {
      SUCCESS: "Audit has been updated successfully.",
      FAILED: "Failed to update audit."
    },
    DELETE: {
      SUCCESS: "Audit has been removed successfully.",
      FAILED: "Failed to remove audit."
    },
    CLOSED: {
      SUCCESS: "Audit has been closed successfully.",
      FAILED: "Failed to close audit."
    },
    GET: {
      AUDIT_TYPE: {
        FAILED: "Failed to fetch audit types."
      },
      AUDIT: {
        FAILED: "Failed to fetch audits."
      },
      SELECT_BRANCH_AND_TYPE: "Please select branch and audit type."
    },
  },

  THIRD_PARTY_AUDIT_MASTER: {
    CREATE: {
      SUCCESS: "Third party audit is created successfully.",
      FAILED: "Failed to create third party audit."
    },
    UPDATE: {
      SUCCESS: "Third party Audit has been updated successfully.",
      FAILED: "Failed to update third party audit."
    },
    DELETE: {
      SUCCESS: "Third party Audit has been removed successfully.",
      FAILED: "Failed to remove third party audit."
    },
    CLOSED: {
      SUCCESS: "Third party Audit has been closed successfully.",
      FAILED: "Failed to close third party audit."
    },
    GET: {
      AUDIT_TYPE: {
        FAILED: "Failed to fetch audit types."
      },
      AUDIT: {
        FAILED: "Failed to fetch audits."
      },
      SELECT_BRANCH_AND_TYPE: "Please select branch and audit type."
    },
  },
  
  REVIEWED_AND_CLOSED: {
    REVIEW: {
      SUCCESS: "Checklist and PPE are saved successfully.",
      FAILED: "Failed to save the data of checklist and ppe."
    },
    CLOSED: {
      SUCCESS: "Work permit is closed successfully.",
      FAILED: "Failed to close work permit."
    }
  },

  AUDIT_TYPE_MASTER: {
    CREATE: {
      SUCCESS: "Audit type is created successfully.",
      FAILED: "Failed to create audit type."
    },
    UPDATE: {
      SUCCESS: "Audit type has been updated successfully.",
      FAILED: "Failed to update audit type."
    },
    DELETE: {
      SUCCESS: "Audit type has been removed successfully.",
      FAILED: "Failed to remove audit type."
    },
    BULK_UPLOAD_ACTIVITIES: {
      REQUIRED_FILE: "Please select an excel file to upload bulk activities.",
      INVALID_FILE_FORMAT: "Invalid file format.",
      AUDIT_TYPE_NAME: "Please enter audit type name.",
      UNIQUE_PREFIX: "Please enter unique prefix for audit type.",
      FAILED: "Failed to create audit type.",
      SUCCESS: "Audit type is created successfully."
    }
  },

  AUDIT_TYPE_CATEGORY_MASTER: {
    CREATE: {
      SUCCESS: "Audit type category is created successfully.",
      FAILED: "Failed to create audit type category."
    },
    UPDATE: {
      SUCCESS: "Audit type category has been updated successfully.",
      FAILED: "Failed to update audit type category."
    },
    DELETE: {
      SUCCESS: "Audit type category has been removed successfully.",
      FAILED: "Failed to remove audit type category."
    },
    DUPLICATE_CATEGORY_NAME: "Category name is already exists."
  },

  COMPANY_MASTER: {
    LOGO_UPLOAD: {
      FAILED: "Failed to upload company logo"
    },
    FETCHED: {
      FAILED: "Failed to fetch company details"
    },
    UPDATE: {
      SUCCESS: "Company information has been updated successfully.",
      FAILED: "Failed to update company information."
    }
  },

  REPORT_MASTER: {
    FETCHED: {
      FAILED: {
        REPORT: "Failed to fetch report.",
        AUDIT_TYPE: "Failed to fetch audit type.",
        BRANCH: "Failed to fetch audit type.",
        DEPARTMENT: "Failed to fetch departments under selected branch.",
        AREA: "Failed to fetch areas under selected department.",
        USERS: "Failed to fetch users under selected branch.",
      }
    },
  },




  // -------------------------- Zingworks Admin Message ---------------------------
  ACCOUNT_MASTER: {
    DUPLICATE_ACCOUNT_NAME: "Company name already exists.",
    FETCHED: {
      FAILED: "Failed to fetch account master.",
    },
    CREATE: {
      SUCCESS: "Company account is created successfully.",
      FAILED: "Failed to create company account."
    },
    UPDATE: {
      SUCCESS: "Company account has been updated successfully.",
      FAILED: "Failed to update company account."
    },
    DELETE: {
      SUCCESS: "Company account has been removed successfully.",
      FAILED: "Failed to remove company account."
    },
  },

  ASSIGN_SUPER_ADMIN_MASTER: {
    UN_ASSIGN: {
      SUCCESS: "Zingworks Super Admin has been successfully unassigned.",
      FAILED: "Failed to unassign Zingworks Super Admin from the account."
    },
    ASSIGN: {
      SUCCESS: "Zingworks Super admin is assigned successfully.",
      FAILED: "Failed to assign super admin."
    },
    ASSIGNED_SUPER_ADMIN_ACCOUNT_ID: {
      SUCCESS: "Account details fetched successfully for the assigned super admin.",
      FAILED: "Failed to fetch account details for the assigned super admin."
    },
    FETCHED: {
      FAILED: "Failed to fetched data."
    },
  },
}